import React, { memo } from 'react'
import styles from './index.less'
import CustomNodeWrapper from '../../configuration/wrapper'
import type { MessageActionNodeData } from '../types'
import type { ComponentType } from 'react'
import type { NodeProps } from 'reactflow'

function MessageNodeRender({
  data,
  selected,
}: NodeProps<MessageActionNodeData>) {
  return (
    <CustomNodeWrapper nodeData={data} selected={selected}>
      <span className={`${styles.nodeText}`}>{data.nodeName}</span>
    </CustomNodeWrapper>
  )
}

const MessageNode: ComponentType<NodeProps<MessageActionNodeData>>
  = memo(MessageNodeRender)

export default MessageNode
